import { create } from 'zustand';

type CookieDialogState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  setIsOpen: (isOpen: boolean) => void;
};

export const useCookieDialogOpen = create<CookieDialogState>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  setIsOpen: (isOpen) => set({ isOpen }),
}));
